module.exports = __webpack_public_path__ + "media/images/dashboard/calendar-565bf5329a49ef97a53ceac7ab3b0814.svg";